<template>
  <div>
    <!-- FILTER -->
    <div class="mt-3">
      <b-row>
        <b-col md="10">
          <b-card class="shadow-sm">
            <b-card-header class="d-flex justify-content-between align-items-center">
              <h4 class="card-title">
                Tarik Laporan Laba Rugi
              </h4>
            </b-card-header>
            <b-card-body>
              <b-alert
                variant="danger"
                class="p-1"
                show
              >
                Maksimal rentang tanggal adalah 32 hari.
              </b-alert>
              <form action="">
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label="Tanggal Transaksi"
                      label-for="f-range-date"
                      label-cols-md="4"
                    >
                      <flat-pickr
                        id="f-range-date"
                        v-model="filter.rangeDate"
                        class="form-control"
                        :config="{ mode: 'range', enableTime: true, dateFormat: 'Y-m-d H:i'}"
                        @on-change="(date) => {
                          filter.startDate = date[0]
                          filter.endDate = date[1]
                        }"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button
                  variant="info"
                  class="float-right"
                  @click="getReport()"
                >
                  <span v-if="loading">
                    <b-spinner
                      small
                      type="border"
                      class="mr-1"
                    /> Loading...
                  </span>
                  <span v-else>
                    Cetak Laporan
                  </span>
                </b-button>
              </form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup, BButton, BCardBody, BCardHeader, BCard, BCol, BRow, BSpinner, BAlert,
} from 'bootstrap-vue'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BSpinner,
    BFormGroup,
    BButton,
    BCardBody,
    BCardHeader,
    BRow,
    BCard,
    BCol,
    BAlert,
    flatPickr,
  },
  data() {
    const today = new Date()
    const start = new Date(today.setHours(0, 0, 0))
    const end = new Date(); end.setHours(23, 59, 0)

    return {
      dir: false,
      loading: false,
      filter: {
        rangeDate: [start, end],
        startDate: start,
        endDate: end,
      },
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {

  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      const pad = n => (n < 10 ? `0${n}` : n)
      const yy = String(date.getFullYear()).slice(2)
      const mm = pad(date.getMonth() + 1)
      const dd = pad(date.getDate())
      return `${yy}-${mm}-${dd}`
    },
    getReport() {
      const payload = {
        start_date: this.formatDate(this.filter.startDate),
        end_date: this.formatDate(this.filter.endDate),
      }

      console.log(payload)
      this.loading = true
      this.$http.post('report/income-statement', payload, {
        responseType: 'blob', // penting untuk PDF
      })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tarik Report Sukses',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
          window.open(fileURL) // untuk buka tab baru
          this.loading = false

          // Atau untuk langsung download:
          // const link = document.createElement('a');
          // link.href = fileURL;
          // link.setAttribute('download', 'laporan-penjualan-global.pdf');
          // document.body.appendChild(link);
          // link.click();
        })
        .catch(err => {
          this.loading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Tarik Report Gagal',
              icon: 'XOctagonIcon',
              variant: 'danger',
            },
          })
          console.error('Gagal ambil PDF:', err)
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
